import { render, staticRenderFns } from "./comView.vue?vue&type=template&id=bb280f02&scoped=true"
import script from "./comView.vue?vue&type=script&lang=js"
export * from "./comView.vue?vue&type=script&lang=js"
import style0 from "./comView.vue?vue&type=style&index=0&id=bb280f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb280f02",
  null
  
)

export default component.exports